import axios from 'axios';
import { browserHistory } from 'react-router';
import { toFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_CUSTOMER_SEARCH,
  CUSTOMER_SEARCH_SUCCESS,
  RETURN_SEARCH_SUCCESS,
  CUSTOMER_SEARCH_FAILURE,
  REQUEST_CUSTOMER_CREATE_RETURN,
  CUSTOMER_CREATE_RETURN_SUCCESS,
  CUSTOMER_CREATE_RETURN_FAILURE,
  REQUEST_CUSTOMER_EDIT_RETURN,
  CUSTOMER_EDIT_RETURN_SUCCESS,
  CUSTOMER_EDIT_RETURN_FAILURE,
  // fix search
  REQUEST_DISPATCH_EDIT_RETURN,
  DISPATCH_EDIT_RETURN_SUCCESS,
  DISPATCH_EDIT_RETURN_FAILURE,
  REQUEST_DISPATCH_SEARCH,
  DISPATCH_SEARCH_SUCCESS,
  DISPATCH_SEARCH_FAILURE,
  SET_RETURNS_FILTER,
  RESET_CURRENT_FORM,
  RESET_CURRENT_RETURN,
  FETCH_CUSTOMERS,
} from "./type";

import { BD_RMA_URL, CUSTOMERS_URL, ROOT_URL } from "./url.js";

export const createRMAOrder = (payload, success, failed) => dispatch => {
  axios({
    method: 'POST',
    url: `${BD_RMA_URL}order/`,
    data: payload,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    }
  })
    .then(res => {
      success();
    })
    .catch(err => {
      failed(err.data);
    })
}

export const changeRMAStatus = (id, status, success, failed) => dispatch => {
  axios({
    method: 'PUT',
    url: `${BD_RMA_URL}change-status/${id}`,
    data: {
      status,
    },
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    }
  })
    .then(res => {
      success();
    })
      .catch(err => {
        failed();
      })
}

export const uploadRMA = (data, success) => dispatch => {
  axios({
    method: 'POST',
    url: `${BD_RMA_URL}import-order `,
    data: data,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      "Content-Type": "multipart/form-data"
    }
  })
    .then(res => {
      success();
      alert('success');
    })
    .catch(err => {
      alert(`ERROR: ${err.data}`);
    })
}

export const editRMAOrder = (payload, id, succes, failed) => dispatch => {
  axios({
    method: 'PUT',
    url: `${BD_RMA_URL}order/${id}`,
    data: payload,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      succes()
    })
    .catch(err => {
      failed()
    })
}

export function fetchCustomers(bool) {
  return dispatch => {
    let mobile = '';
    if (bool === true) { mobile = `&include_Mobile_Customer=true`; }

    axios.get(
      `${CUSTOMERS_URL}?Customer_id__IsActive=1${mobile}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch({
          type: FETCH_CUSTOMERS,
          payload: response.data,
        })
        // dispatch(fetchReturnSuccess(response.data))
      })
      .catch(err => {
        // console.log('fetch fail this is the err', err)
      })
  }
}

export function fetchCustomerReturnsByFilter(postingDateGT, postingDateLT, days, status, page, currentCustomer, search) {
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  if (status) {
    if (status == 'all') {
      status = '';
    } else {
      status = `&Fix_Status=${status}`;
    }
  }
  let rma_num = '', customer = '';
  // let customer = '';
  if (currentCustomer) {
    customer = `&customerId=${currentCustomer.value}`;
  };
  if (search) {
    rma_num = `&keyword=${search}`;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_SEARCH });
    return axios.get(
      `${BD_RMA_URL}order/?start_date=${dates.fromDate
      }&end_date=${dates.toDate}&limit=20&page=${page}${rma_num}${customer}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(response => {
        dispatch(fetchCustomerReturnsByFilterSuccess(response))
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerReturnsByFilterFailure(err));
      });
  };
}

export function fetchCustomerReturnsByFilterSuccess(data) {
  return {
    type: CUSTOMER_SEARCH_SUCCESS,
    payload: data
  }
}

export function fetchCustomerReturnsByFilterFailure(err) {
  return {
    type: CUSTOMER_SEARCH_FAILURE
  }
}

export function createCustomerReturn({
  RMA_Content,
  RMA_Service_Type,
  RMA_Num,
  Product_SN,
  Product_Description,
  Return_Logitics_Company,
  Return_Tracking_Num,
  Is_Urgent,
  Is_Warranty,
  Customer_Name,
  Customer_Mobile,
  Customer_Address,
  Customer_Email,
  Submit_Description1,
  Submit_Description2,
  Product_Model,
}) {
  if (typeof Is_Urgent === "object") {
    Is_Urgent = Is_Urgent.value
  }
  if (typeof Is_Warranty === "object") {
    Is_Warranty = Is_Warranty.value
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_CREATE_RETURN });
    return axios.post(
      `${BD_RMA_URL}`,
      {
        RMA_Content,
        RMA_Service_Type,
        RMA_Num,
        Product_SN,
        Product_Description,
        Return_Logitics_Company,
        Return_Tracking_Num,
        Is_Urgent,
        Is_Warranty,
        Customer_Name,
        Customer_Mobile,
        Customer_Address,
        Customer_Email,
        Submit_Description1,
        Submit_Description2,
        Product_Model,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(response => {
        dispatch(createCustomerReturnSuccess(response));
        browserHistory.push('/customerRMA');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        alert(err.data)
        dispatch(createCustomerReturnFailure(err));
      })
  }
}

export function createCustomerReturnSuccess(data) {
  return {
    type: CUSTOMER_CREATE_RETURN_SUCCESS,
    payload: data
  }
}

export function createCustomerReturnFailure(err) {
  return {
    type: CUSTOMER_CREATE_RETURN_FAILURE
  }
}

export function editCustomerReturn({
  RMA_ID,
  RMA_Content,
  RMA_Service_Type,
  RMA_Num,
  Product_SN,
  Product_Description,
  Return_Logitics_Company,
  Return_Tracking_Num,
  Is_Urgent,
  Is_Warranty,
  Customer_Name,
  Customer_Mobile,
  Customer_Address,
  Customer_Email,
  Submit_Description1,
  Submit_Description2,
  Product_Model,

  Openbox_Description,
  Product_Detail_Info,
  Warehouse_Check_Info,
  Fix_Status,
  Fix_Description1,
  Fix_Description2,

  Dispatch_Logiticis_Company,
  Dispatch_Tracking_Num,
  Dispatch_Fee,
  Dispatch_Date,
  Person_Dispatch,
  Dispatch_Description1,
  Dispatch_Description2,

  onCustomerEditPage,
}) {
  if (typeof Is_Urgent === "object") {
    Is_Urgent = Is_Urgent.value;
  }
  if (typeof Is_Warranty === "object") {
    Is_Warranty = Is_Warranty.value;
  }
  if (typeof Fix_Status === "object") {
    Fix_Status = Fix_Status.value;
  }
  return dispatch => {
    dispatch({ type: REQUEST_CUSTOMER_EDIT_RETURN });
    return axios.put(
      `${BD_RMA_URL}` + RMA_ID,
      {
        RMA_Content,
        RMA_Service_Type,
        RMA_Num,
        Product_SN,
        Product_Description,
        Return_Logitics_Company,
        Return_Tracking_Num,
        Is_Urgent,
        Is_Warranty,
        Customer_Name,
        Customer_Mobile,
        Customer_Address,
        Customer_Email,
        Submit_Description1,
        Submit_Description2,
        Openbox_Description,
        Product_Detail_Info,
        Warehouse_Check_Info,
        Fix_Status,
        Fix_Description1,
        Fix_Description2,
        Dispatch_Logiticis_Company,
        Dispatch_Tracking_Num,
        Dispatch_Fee,
        Dispatch_Date,
        Person_Dispatch,
        Dispatch_Description1,
        Dispatch_Description2,
        Product_Model,
      },
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(editCustomerReturnSuccess(response));
        if (onCustomerEditPage) {
          browserHistory.push('/customerRMA');
        } else {
          browserHistory.push('/dispatchRMA');
        }
      }, (err) => {
        // if (err.status === 500 || err.status === 404) {
        //     err.status = DEFAULT_ERROR;
        // }
        alert(JSON.stringify(err.data));
        dispatch(editCustomerReturnFailure(err));
      })
  }
}

export function editCustomerReturnSuccess(data) {
  return {
    type: CUSTOMER_EDIT_RETURN_SUCCESS,
    payload: data
  }
}

export function editCustomerReturnFailure(err) {
  return {
    type: CUSTOMER_EDIT_RETURN_FAILURE
  }
}

export function fetchCustomerReturn(id) {
  return dispatch => {
    axios.get(
      `${BD_RMA_URL}order/${id}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch(fetchReturnSuccess(response.data))
      })
      .catch(err => {
        console.log('fetch fail this is the err', err)
      })
  }
}

export function fetchReturnSuccess(data) {
  return {
    type: RETURN_SEARCH_SUCCESS,
    payload: data,
  }
}

export function dispatchEditReturn({
  Fix_Status,
  Dispatch_Logiticis_Company,
  Dispatch_Tracking_Num,
  Dispatch_Fee,
  Dispatch_Date,
  Person_Dispatch,
  Dispatch_Description1,
  Dispatch_Description2
}, fixId) {
  return dispatch => {
    dispatch(REQUEST_DISPATCH_EDIT_RETURN);
    return axios.put(
      `${BD_RMA_URL}fix/${fixId}`,
      {
        Fix_Status,
        Dispatch_Logiticis_Company,
        Dispatch_Tracking_Num,
        Dispatch_Fee,
        Dispatch_Date,
        Person_Dispatch,
        Dispatch_Description1,
        Dispatch_Description2
      },
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(dispatchEditReturnSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR
        }
        dispatch(dispatchEditReturnFailure(err));
      })
  }
}

export function dispatchEditReturnSuccess(data) {
  return {
    type: DISPATCH_EDIT_RETURN_SUCCESS,
    payload: data
  }
}

export function dispatchEditReturnFailure(err) {
  return {
    type: DISPATCH_EDIT_RETURN_FAILURE
  }
}


export function fetchDispatchReturns(postingDateGT, postingDateLT, days, status, search) {
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  if (status) {
    if (status == 'all') {
      status = '';
    } else {
      status = `&Fix_Status=${status}`;
    }
  }
  if (search) {
    search = `&search=${search}`
  } else {
    search = '';
  }
  return dispatch => {
    dispatch({ type: REQUEST_DISPATCH_SEARCH });
    return axios.get(
      `${BD_RMA_URL}fix/search/?Date_Created__gte=${dates.fromDate
      }&Date_Created__lte=${dates.toDate}${status}${search}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch(fetchDispatchReturnsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchDispatchReturnsFailure(err));
      })
  }
}

export function fetchDispatchReturnsSuccess(data) {
  return {
    type: DISPATCH_SEARCH_SUCCESS,
    payload: data,
  }
}

export function fetchDispatchReturnsFailure(err) {
  return {
    type: DISPATCH_SEARCH_FAILURE
  }
}

export function setReturnsFilter(data) {
  return {
    type: SET_RETURNS_FILTER,
    payload: data,
  };
}

export function resetCurrentForm() {
  return {
    type: RESET_CURRENT_FORM,
  };
}

export function clearCurrentReturn() {
  return {
    type: RESET_CURRENT_RETURN
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/rma_actions.js